export var LOAD_CONFIG = 'APP_LOAD_CONFIG';
export var loadConfig = function loadConfig(action) {
  var ficheroConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'recursos/config';
  var ficheroPaginas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'contenido/paginas';
  return {
    type: LOAD_CONFIG,
    ficheroConfig: ficheroConfig,
    ficheroPaginas: ficheroPaginas,
    action: action
  };
};
export var SET_CADUCADO = 'APP_SET_CADUCADO';
export var setCaducado = function setCaducado(caducado, msg) {
  return {
    type: SET_CADUCADO,
    caducado: caducado,
    msg: msg
  };
};
export var SET_MENSAJE_CADUCIDAD = 'APP_SET_MENSAJE_CADUCIDAD';
export var setMensajeCaducidad = function setMensajeCaducidad(msg) {
  return {
    type: SET_MENSAJE_CADUCIDAD,
    msgCaducidad: msg
  };
};
export var INICIALIZAR = 'APP_INICIALIZAR';
export var inicializar = function inicializar(config, paginas) {
  return {
    type: INICIALIZAR,
    config: config,
    paginas: paginas
  };
};
export var LOAD_ERROR = 'APP_LOAD_ERROR';
export var loadError = function loadError(error) {
  return {
    type: LOAD_ERROR,
    error: error
  };
};
export var CONFIGURACION_PAGINA_CARGADA = 'LIBRO_CONFIGURACION_PAGINA_CARGADA';
export var configuracionPaginaCargada = function configuracionPaginaCargada(libroId, numPagina, data) {
  return {
    type: CONFIGURACION_PAGINA_CARGADA,
    libroId: libroId,
    numPagina: numPagina,
    data: data
  };
}; // La accion pantalla, no cambia el estado, solo informa de la intención de ir a esa pantalla
// De esta forma, se pueden realizar acciones extras (mediante sagas) antes de cambiar de pantalla

export var PANTALLA = 'APP_PANTALLA';
export var pantalla = function pantalla(pantallaId, props) {
  return {
    type: PANTALLA,
    pantallaId: pantallaId,
    props: props
  };
}; // Esta es la acción que realmente cambia de pantalla, y debe permanecer privada en ibook-api
// Se llama automaticamente mediante sagas despues de la accion PANTALLA

export var CONSOLIDAR_PANTALLA = 'APP_PANTALLA_CONSOLIDAR';
export var consolidarPantalla = function consolidarPantalla(pantallaId, props) {
  return {
    type: CONSOLIDAR_PANTALLA,
    pantallaId: pantallaId,
    props: props
  };
};
export var ADD_PANTALLA = 'APP_PANTALLA_ADD';
export var addPantalla = function addPantalla(pantallaId, pantallaComponent) {
  return {
    type: ADD_PANTALLA,
    pantallaId: pantallaId,
    pantallaComponent: pantallaComponent
  };
};
export var EJECUTAR_FUNCION = 'APP_EJECUTAR_FUNCION';
export var ejecutarFuncion = function ejecutarFuncion(libroId, numPagina, numZona, nombre, params) {
  return {
    type: EJECUTAR_FUNCION,
    libroId: libroId,
    numPagina: numPagina,
    numZona: numZona,
    nombre: nombre,
    params: params
  };
};
export var ZONA = 'APP_ZONA';
export var zona = function zona(libroId, numPagina, numZona) {
  return {
    type: ZONA,
    libroId: libroId,
    numPagina: numPagina,
    numZona: numZona
  };
};
export var NOTAS = 'APP_NOTAS';
export var notas = function notas() {
  return {
    type: NOTAS
  };
};
export * from './barra-herramientas'; // export * from './textos-usuario'

export * from './imagen-usuario';
export * from './reloj';
export * from '../gestor-sesiones/actions';